// extracted by mini-css-extract-plugin
module.exports = {"header":"FaqDetail_header__i2lZy","title":"FaqDetail_title__x_tAp","text":"FaqDetail_text__tyi9T"};